import AuthService from "service/Auth";
import TokenService from "service/Token";

export const getRole = () => {
  const isAuthenticated = !!TokenService.getIsAuthenticated();

  return isAuthenticated ? AuthService.getDataAuth().role : "";
};
